import withNavigate from "../../util/useNavigate";
import {withAppContext} from "../../util/withAppContext";
import withBreakpoint from "../../util/withBreakpoint";
import {PlatformTable2} from "../PlatformTable2";

class DocumentRevisionTable extends PlatformTable2 {


}

export default withNavigate(withAppContext(withBreakpoint(DocumentRevisionTable)));